import { OrderComplainModel } from './order-complain';
export class PayAuthorityModel {
  public ID?: number;
  public UID?: number;
  public Username?: string;
  public Status?: number;
  public Amount?: number;
  public AmountVND?: number;
  public Fee?: number;
  public FeeVND?: number;
  public TotalAmount?: number;
  public AcceptPayAccount?: string;
  public ExchangeRate?: number;
  public Type?: number;
  public NumberDetail?: number;
  public Content?: string;
  public Refund?: number;
  public Dispute?: string;
  public CreatedBy?: string;
  public CreatedDate?: string;
  public QuotationID?: number;
  public statusDetail?: any;
  public OrderCodes?: PayServiceOrderCodeModel[] = [];
  public Complains!: OrderComplainModel[];
}

export class SummaryPayAuthorityModel {
  public TotalStatusAll!: number;
  public TotalStatus1!: number;
  public TotalStatus2!: number;
  public TotalStatus3!: number;
  public TotalStatus4!: number;
  public TotalStatus5!: number;
  public TotalStatus6!: number;
}

export class PayServiceOrderCodeModel {
  public ID?: number;
  public ParentID?: number;
  public Cancelled?: number;
  public Amount?: number;
  public PayID?: number;
  public OrderCode?: string;
  public LinkPay?: string;
  public Note?: string;
}
